import request from "../api/agent";

const API_ROUTE = "autoreporter";

export class ReportService {


async getAutoreRorter(page, limit, date_range, status, report_type,group_id,weekly_monthly,filter_user) {
  const response = await request.get(`${API_ROUTE}/report-listing`, {
    params: {
      page,
      limit,
      date_range,
      status:Array.isArray(status) ? status.join(",") : "",
      report_type:Array.isArray(report_type) ? report_type.join(",") : "",
      group_id:Array.isArray(group_id) ? group_id.join(",") : "",
      report:Array.isArray(weekly_monthly) ? weekly_monthly.join(",") : "",
      filter_user:Array.isArray(filter_user) ? filter_user.join(",") : "",
    }
  });

  return response.data ?? response?.response?.data;
}
  
}